import {Component} from "@angular/core";
import {provideEntityModel, provideReportModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CreditInvoiceSearchModel} from "../credit-invoice-search.model";
import {CreditInvoiceEntityModel} from "../credit-invoice-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {CreditInvoiceReportModel} from "../../reports/credit-invoice-report/credit-invoice-report.model";

@Component({
    selector: "wbo-credit-invoice-search-page",
    templateUrl: "./credit-invoice-search-page.component.html",
    providers: [provideSearchModel(CreditInvoiceSearchModel), provideEntityModel(CreditInvoiceEntityModel), provideReportModel(CreditInvoiceReportModel)]
})

export class CreditInvoiceSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
